// frontend/src/App.js
import React, { useContext } from 'react';
import { AuthContext } from './context/AuthContext';
import FiscalDataTable from './components/FiscalDataTable';
import MonitoringPage from './components/MonitoringPage';
import Login from './components/Login'; // Импортируем Login
import ProtectedRoute from './components/ProtectedRoute'; // Импортируем ProtectedRoute
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { BrowserRouter as Router, Routes, Route, Link, useNavigate } from 'react-router-dom';
import { Button, Box } from '@mui/material';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import OfdCredentialsPage from './components/OfdCredentialsPage';
import TestMonitoringTable from './components/TestMonitoringTable';
import Client2MonitoringPage from './components/Client2MonitoringPage';
// --- ИМПОРТ ДЛЯ СЕКОНДХЕНДОВ БОЛЬШЕ НЕ НУЖЕН ---
// import SecondhandDashboard from './components/SecondhandDashboard'; // <-- Закомментировать или удалить
// --- КОНЕЦ ИМПОРТА ---

// Определяем кастомную СВЕТЛУЮ тему с синими акцентами
const customTheme = createTheme({
  palette: {
    mode: 'light', // Светлая тема
    primary: {
      main: '#1976d2', // Основной синий цвет
    },
    secondary: {
      main: '#dc004e', // Вторичный красный цвет
    },
    background: {
      default: '#f5f5f5', // Светло-серый фон по умолчанию
      paper: '#ffffff',   // Белый фон для карточек и панелей
    },
    text: {
      primary: '#212121', // Темно-серый текст по умолчанию
      secondary: '#757575', // Светло-серый вторичный текст
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h4: {
      fontWeight: 500,
    },
  },
  components: {
    MuiTableCell: {
      styleOverrides: {
        head: {
          backgroundColor: '#e3f2fd', // Светло-голубой фон для заголовков таблиц
          color: '#1976d2', // Синий цвет текста заголовков
          fontWeight: 'bold',
        },
      },
    },
    MuiTableSortLabel: {
      styleOverrides: {
        icon: {
          color: '#1976d2 !important', // Синий цвет иконок сортировки
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none', // Отключаем автоматическое преобразование регистра
        },
      },
    },
  },
});

// --- НОВОЕ: Компонент для кнопки "Выйти" ---
function LogoutButton() {
  const { logout } = useContext(AuthContext);
  const navigate = useNavigate(); // <-- Используем useNavigate

  const handleLogout = () => {
    logout();
    navigate('/login'); // Перенаправляем на страницу входа
  };

  return (
    <Button color="inherit" onClick={handleLogout}>
      Выйти
    </Button>
  );
}
// --- КОНЕЦ НОВОГО --

function App() {
  const { token } = useContext(AuthContext); // <-- Получаем токен из контекста

  return (
    <ThemeProvider theme={customTheme}>
      <CssBaseline />
      <div>
        <Router>
          {/* AppBar отображается всегда, но содержимое зависит от аутентификации */}
          <AppBar position="static">
            <Toolbar>
              {/* Отображаем навигационные кнопки только если пользователь залогинен */}
              {token && (
                <>
                  <Button color="inherit" component={Link} to="/">
                    Сроки замен
                  </Button>
                  <Button color="inherit" component={Link} to="/monitoring">
                    EBS
                  </Button>
                  <Button color="inherit" component={Link} to="/client2">
                    Главпиво
                  </Button>
                  <Button
                    color="inherit"
                    href="/status/secondhand" // <-- Относительный путь // <-- Внешний URL
                    target="_blank"                                    // <-- Открывает в новой вкладке
                    rel="noopener noreferrer"                          // <-- Безопасность: предотвращает доступ новой вкладки к текущей
                  >
                    Секондхенды
                  </Button>
                  <Button color="inherit" component={Link} to="/ofd-credentials">
                    Учетные данные
                  </Button>
                  {/* --- НОВОЕ: Кнопка "Секондхенды", открывающая URL в новой вкладке --- */}

                  {/* --- КОНЕЦ НОВОГО --- */}

                  {/* --- НОВОЕ: Кнопка "Выйти" --- */}
                  <Box sx={{ marginLeft: 'auto' }}> {/* Отправляем кнопку вправо */}
                    <LogoutButton />
                  </Box>
                  {/* --- КОНЕЦ НОВОГО --- */}
                </>
              )}
            </Toolbar>
          </AppBar>
          <Box component="main" sx={{ p: 3 }}>
            <Routes>
              {/* Маршрут для страницы входа */}
              <Route path="/login" element={<Login />} />
              {/* Защищенные маршруты */}
              <Route
                path="/"
                element={
                  <ProtectedRoute>
                    <FiscalDataTable />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/monitoring"
                element={
                  <ProtectedRoute>
                    <MonitoringPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/ofd-credentials"
                element={
                  <ProtectedRoute>
                    <OfdCredentialsPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/client2"
                element={
                  <ProtectedRoute>
                    <Client2MonitoringPage />
                  </ProtectedRoute>
                }
              />
              {/* --- МАРШРУТ ДЛЯ СЕКОНДХЕНДОВ БОЛЬШЕ НЕ НУЖЕН ---
              <Route
                path="/secondhand"
                element={
                  <ProtectedRoute>
                    <SecondhandDashboard />
                  </ProtectedRoute>
                }
              />
              --- КОНЕЦ МАРШРУТА --- */}
            </Routes>
          </Box>
        </Router>
      </div>
    </ThemeProvider>
  );
}

export default App;